import $ from "jquery";
window.$ = window.jQuery = $;
import "slick-carousel";
import "iframe-resizer";
import * as parallax from "./parallax";
import "./nav";
import "./providers";
import "./utm_params";
import "@fortawesome/fontawesome-free/js/fontawesome.js";
import "@fortawesome/fontawesome-free/js/solid.js";
import { createChat } from '@n8n/chat';

$(document).ready(function() {

	iFrameResize({}, document.querySelector('#contactform'));

	$('.doc table').each(function() {
		$(this).wrap('<div class="table-wrapper">');
	});

	$(document).on('click', 'figure.can-fullscreen', function() {
		$(this).toggleClass('is-fullscreen');
	});

    // Scroll animation effects
    parallax.init();

	// n8n Chat
	let i18n;
	let initialMessages;
	if (document.documentElement.lang === 'de') {
		i18n = {
			en: {
				title: 'integraid Chat',
				subtitle: '',
				footer: '',
				getStarted: 'Klicke hier, um unsere Datenschutzbestimmungen zu akzeptieren. Wir nutzen KI, um Deine Fragen zu beantworten.',
				inputPlaceholder: 'Gib deine Frage ein..',
			},
		};
		initialMessages = ['👋 Hallo! Wie können wir Dir helfen?'];
	} else {
		i18n = {
			en: {
				title: 'integraid Chat',
				subtitle: '',
				footer: '',
				getStarted: 'Click here to accept our privacy policy. We use AI to answer your questions.',
				inputPlaceholder: 'Type your question..',
			},
		};
		initialMessages = ['👋 Hello! How can we assist you?'];
	}
	createChat({
		webhookUrl: 'https://cloudworx.app.n8n.cloud/webhook/4aaac05d-418e-4927-a97a-584a98e571f9/chat',
		showWelcomeScreen: true,
		defaultLanguage: 'en',
		i18n: i18n,
		initialMessages: initialMessages,
		metadata: {
			initialLanguage: document.documentElement.lang,
			pageUrl: window.location.href,
			pageDomain: window.location.hostname,
		}
	});

	$('.slick').each(function() {
		var slider = $(this);
		slider.slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: slider.siblings('.slick-arrow-left'),
			nextArrow: slider.siblings('.slick-arrow-right'),
			draggable: true,
			speed: 750,
			autoplaySpeed: 5000
		});
	});

});
